export class Industry {
  id: number;
  name: string;
  createdDate: string;
  modifiedDate: string | null;
  category?: IndustryCategory;
}

export class IndustryCategory {
  id: number;
  name: string;
  createdDate: string;
  modifiedDate: string | null;
}
export class Tenant {
  id: number;
  name: string;
  industry: Industry;
  country: string;
  contactUrl: string;
  contactPhone: string;
  contactName: string;
  contactEmail?: string | null;
  createdDate: string;
  modifiedDate?: string | null;
  developer: boolean;
  owner: boolean;
  tenant: boolean;
  status: string = "Active";
  action: string;
}

export interface CorporationSubsidiary {
  id: number;
  name: string;
}

export interface Corporation {
  id: number;
  name: string;
  status: string;
  propertyCount: number;
  hasSubsidiaries: boolean;
  subsidiaries: CorporationSubsidiary[];
  relatedPropertyIds: string;
  relatedPropertyIdsInStats: string;
  corporationPropertyType?: string;
}

export interface TenantSearchResponse {
  content: Tenant[];
  totalElements: number;
}

export interface BuildingRentRoll {
  dateEntered: unknown;
  publishedDate?: unknown;
  [key: string]: unknown;
}

export class TenantDetail {
  warehouse?: string;
  floor?: string;
  module?: string;
  suiteNumber?: string;
  area: string;
  bomaArea?: string;
  moduleEfficiency?: string;
  docksModule?: string;
  tenantName: string;

  owners: string;
  ownersGroup: string;
  ownersContactName: string;
  ownersContactEmail: string;
  ownersContactPhone: string;
}
